import { createApi } from '@reduxjs/toolkit/query/react';

import { ResponseError } from '@/types/Error';
import { LeadGenerationCustomerInfo } from '@/types/LeadGeneration';
import { SuccessResponse } from '@/types/Success';

import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

const contentTypes = {
  applicationJson: 'application/json',
};

export const leadGenerationApi = createApi({
  reducerPath: 'leadGenerationApi',
  keepUnusedDataFor: 300,
  // baseQuery: fetchBaseQuery({
  //   baseUrl: `${SERVER_URL}/LeadGeneration`,
  //   prepareHeaders: headers => {
  //     const { origin, host } = globalThis.window?.location || {};
  //     headers.append('Origin', origin);
  //     headers.append('Host', host);
  //     headers.append('__Origin', origin);
  //     return headers;
  //   },
  // }),
  baseQuery: generateBaseQuseryWithReAuth({ basePath: 'LeadGeneration' }),
  tagTypes: ['LeadGenerations'],
  endpoints: builder => ({
    createNewLead: builder.mutation<SuccessResponse<unknown>, LeadGenerationCustomerInfo>({
      query: payload => ({
        url: `/CreateNewLead`,
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Content-Type': contentTypes.applicationJson,
        },
      }),
      transformResponse: (response: SuccessResponse<unknown>, meta, arg) => response,
      transformErrorResponse: response => response as ResponseError,
    }),
  }),
});

export const { useCreateNewLeadMutation } = leadGenerationApi;
